<template>
	<div>
		<Header></Header>
		<div class="main">
			<div class="main-container">
				<!-- -->
				<div class="bar">
					<div class="tab">
						<span v-for="(item,index) in tabs" :key="item.id" :class="{active:index == num}" @click="tab(index)">{{item}}</span>
					</div>
					<div class="course">
						<div class="c-targ">适用课程</div>
						<div class="item">
							<span class="tag" v-for="(item,index) in courseTabs" :key="item.id" :class="index === tabCourActiveId ? 'current': ''" @click="onCourseTypeTab(index)">{{ item }}</span>
						</div>
					</div>
					<div class="course">
						<div class="c-targ">适用分类</div>
						<div class="item">
							<!-- <span class="tag">全部</span> -->
							<span class="tag" :class="item.id === tabActiveId ? 'current': ''" v-for="item in couponsTypeList" :key="item.id" @click="onCoupontTypeTab(item)">{{ item.name }}</span>
							<div class="tag-child" v-if="tabChildren.length > 0">
								<span :class="it.id == tabActiveId ? 'current': ''" v-for="it in tabChildren" :key="it.id+1" @click="onCoupontTypeTabChildren(it)">{{ it.name }}</span>
							</div>
						</div>
					</div>
				</div>
				<!-- 优惠券列表 -->
				<List
					class="list"
					ref="list"
					url="/api/app/coupon/list"
					:search="search"
					:limit="15"
					:alwaysShowPager="true"
					@page-load="onFormatter"
				>
					<template v-slot="{ list }">
						
							<div class="c-list" v-if="list.length">
								<!-- <template> -->
									<div class="item" v-for="item in list" :key="item.id">
										<div class="left">
											<span class="t" v-if="item.dis_type == 1">{{ item.scope_type == 1 ? '全部课程' : '指定课程'  }}</span>
											<span class="t" v-else-if="item.dis_type == 2">{{ item.scope_type == 1 ? '全部图书' : '指定图书' }}</span>
											<!-- <div class="t" v-if="item.scope_type == 1">全部课程可用</div>
											<div class="t" v-if="item.scope_type == 2">指定分类可用</div>
											<div class="t" v-if="item.scope_type == 3">指定课程可用</div> -->
											<!-- <div class="t" v-else>指定课程可用</div> -->
											<div class="money"><span>¥</span>{{ item.discounted_price }}</div>
										</div>
										<div class="middle">
											<div class="t">满 {{ item.full_reduction }} 元可用</div>
											<div class="text">
												<p v-if="item.valid_day == 0">{{ item.valid_start }}-{{ item.valid_end }}</p>
												<p v-else>领取后{{ item.valid_day }}天有效</p>
												<p><span v-if="item.restrict_num > 1">每人限领{{ item.restrict_num }}张 </span> 限量发放{{ item.num }}张</p>
											</div>
										</div>
										<div class="right">
											<div class="lq" v-if="item.is_can_get == 0" @click="clickReceive(item.id)">立即领取</div>
											<div class="ylq" v-if="item.is_can_get == 1">已领取</div>
										</div>
									</div>
								<!-- </template> -->
							</div>
						<div class="c-list" v-if="list.length == 0">
							<div class="none"><img src="@/assets/img/img_card_none.png"><p>还未有优惠券哦～</p></div>
						</div>
					</template>
				</List>

				
			</div>
		</div>
	</div>
</template>
<script>
import Header from '../../components/Header.vue'
import List from "../../components/List.vue"
export default {
	name: 'Index',
	components: {
		Header,
		List
	},
	data() {
		return {
			tabs: ["课程", "图书"],
			courseTabs: ['指定', '通用'],
			num: 0,
			tabActiveId: '',
			tabCourActiveId: 0,
			couponsTypeList:'',
			tabChildren:[],
			search: {
				dis_type: 1,
				commodity_id: '',
				scope_type: '2,3,4',
				parent_id: ''
			},
			active: 0,
			valid_value: ''
		}
	},
	watch: {
    $route() {
      this.$refs.list.searchRefresh();
    }
  },
	created() {
		this.getCourseClassify()
	},


	methods: {
		onFormatter(rows){
			rows.list.forEach(i => {
				i.discounted_price = i.discounted_price / 100
        i.full_reduction = i.full_reduction / 100
				// i.valid_start = this.$pub.dislodgeZero(new Date(parseInt(i.valid_start) * 1000).format("yyyy/MM/dd"))
				// i.valid_end = this.$pub.dislodgeZero(new Date(parseInt(i.valid_end) * 1000).format("yyyy/MM/dd"))
				i.valid_end = this.$pub.tsToTime(i.valid_end, false)
				i.valid_start = this.$pub.tsToTime(i.valid_start, false)
      });
		},

		tab(index) {
			console.log(index)
				this.num = index
				this.couponsTypeList = ''
				this.tabChildren = ''
				this.tabCourActiveId = 0
				this.tabActiveId = ''
				if(index == 0){ // 课程
					this.getCourseClassify()
					this.search = {
						dis_type: 1,
						commodity_id: '',
						scope_type: '2,3,4',
						parent_id: ''
					}
				}
				if(index == 1){  // 图书
					this.getBookClassify()
					this.search = {
						dis_type: 2,
						commodity_id: '',
						scope_type: '2,3,4',
						parent_id: ''
					}
				}
			
				this.$refs.list.searchRefresh();
		},

		onCourseTypeTab(index){
			this.tabCourActiveId = index
			this.tabActiveId = ''
			if(index == 0){ 
				this.search.scope_type = '2,3,4'
			}
			if(index == 1){
				this.search.scope_type = 1
			}
			this.search.commodity_id = ''
			this.search.parent_id = ''
			this.$refs.list.searchRefresh();
		},

		onCoupontTypeTab(item){
			console.log(item)
			this.tabActiveId = item.id
			this.tabCourActiveId = ''
			if(item.children){
				this.tabChildren = item.children
			}else{
				this.tabChildren = []
			}
			this.search.scope_type = '2,3,4'
			this.search.commodity_id = item.id
			this.search.parent_id = item.id
			this.$refs.list.searchRefresh();
		},

		onCoupontTypeTabChildren(it){
			console.log('二级分类---',it)
			this.tabActiveId = it.id
			this.search.scope_type = '2,3,4'
			this.search.commodity_id = it.id
			this.search.parent_id = ''
			this.$refs.list.searchRefresh();
		},

		async getCouponsList(){
			let data = await this.$http.get('/api/app/coupon/list')
			this.couponsList = data.list
		},

		//
		async getCourseClassify(){
			let data = await this.$http.get('/api/app/course/classify')
			this.couponsTypeList = data
		},
		async getBookClassify(){
			let data = await this.$http.get('/api/app/book/classify')
			this.couponsTypeList = data
		},

		// 立即领取 
		async clickReceive(id){
		
			if(!localStorage.getItem('studentToken')){
				let url = process.env.VUR_APP_LOGING_URL + '/login?return_url=' + encodeURIComponent(window.location.href)
      	window.open(url, '_self')
			}
			await this.$http.get('/api/app/userGetCoupon/' + id)
			await this.$success("领取成功，请到个人中心查看!");
			this.$refs.list.searchRefresh();
		}

	}
}
</script>
<style lang="scss" scoped>
.main {
	min-height: calc(100vh - 218px);
	padding-top: 70px;
}

.main-container {
	width: 1200px;
	margin-left: auto;
	margin-right: auto;
	.bar {
		margin: 24px 0 22px 0;
		padding: 23px 34px 0 34px;
		background: #fff;
		border-radius: 5px;
		.tab {
			margin-bottom: 30px;
		}
		.tab span {
			height: 3px;
			font-weight: bold;
			margin-right: 30px;
			cursor: pointer;
		}
		.tab .active {
			border-bottom: 3px solid #E60012;
		}
		.course {
			display: flex;
			.c-targ {
				white-space: nowrap;
			}
		}
		.item {
			margin-left: 20px;
			.tag-child {
				padding: 0 30px;
			}
			.tag-child span{
				height: 24px;
				border-radius: 5px;
				padding: 0 11px;
				font-size: 14px;
				color: #333;
				line-height: 24px;
				cursor: pointer;
				margin: 0 22px 20px 0;
				display: inline-block;
			}
			.tag-child span.current {
				background-color: #ff0036 !important;
				color: #fff;
			}
		}
		.item .tag {
			height: 24px;
			border-radius: 5px;
			padding: 0 11px;
			font-size: 14px;
			color: #333;
			line-height: 24px;
			cursor: pointer;
			margin: 0 22px 20px 0;
			display: inline-block;
		}
		.item .tag.current {
			background-color: #ff0036 !important;
			color: #fff;
		}
	}

	.list {
		
		.c-list {
			max-height: 600px;
			display: flex;
			flex-wrap: wrap;
			padding: 35px 0 35px 36px;
			background: #ffffff;
			border: 3px solid #ffffff;
			border-radius: 10px;
			.none {
				text-align: center;
				margin: 100px auto;
				color: #999;
				font-size: 20px;
			}
			.none img{
				width: 280px;
			}
		}
		.c-list .item {
			// height: 103px;
			width: 31%;
			background-image: url('~@/assets/img/img_bg_card.png');
			background-repeat: no-repeat;
			background-size: 100% 100%;
			margin-right: 25px;
			margin-bottom: 23px;
		}
		.c-list .item:nth-child(3n) {
			margin-right: 0;
		}
		.c-list .item .left {
			float: left;
			margin-left: 17px;
			margin-top: 10px;
			.t {
				height: 16px;
				background: #ffffff;
				border-radius: 8px;
				font-size: 10px;
				color: #ee060d;
				padding: 3px 9px;
				text-align: center;
			}
			.money {
				height: 34px;
				font-size: 32px;
				font-weight: 500;
				color: #ee060d;
				width: 90px;
				margin-top: 8px;
				span {
					font-size: 12px;
				}
			}
		}
		.c-list .item .middle {
			float: left;
			width: 47%;
			margin-top: 30px;
			margin-left: 14px;
			.t {
				font-size: 16px;
				font-weight: 500;
				color: #ee060d;
			}
			.text {
				font-size: 10px;
				font-weight: 400;
				color: #222;
				margin-top: 8px;
				margin-bottom: 8px;
				transform: scale(0.9);
				margin-left: -8px;
			}
			.text p {
				margin: 0;
				white-space: nowrap;
    		letter-spacing: -1px;
			}
		}
		.c-list .item .right {
			float: right;
			width: 6%;
			margin-right: 22px;
			.lq {
				font-size: 12px;
				font-weight: 500;
				color: #e80209;
				padding: 13px 0px;
				line-height: 20px;
				cursor: pointer;
				text-align: center;
			}
			.ylq {
				font-size: 12px;
				font-weight: 500;
				color: #fff;
				padding: 20px 0px;
				line-height: 20px;
				text-align: center;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/Home/index.vue